import styles from './index.module.scss'
import { filter } from '../../../data/filter'
import { music } from '../../../data/music'
import { utils } from '../../../data/utils'
import { info } from '../../../data/info'

export default function Table() {
  return (
    <div>
      <div className={styles.table}>
        <table>
          <tbody>
            <tr className={styles.headers}>
              <td>Filter Commands</td>
            </tr>
            {filter.map((cmd, index) => (
              <tr key={index} className={styles.trcolor}>
                <td className={styles.tdspace}>/filter {cmd.name}</td>
                <td>{cmd.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.table}>
      <table>
          <tbody>
            <tr className={styles.headers}>
              <td>Music Commands</td>
            </tr>
            {music.map((cmd, index) => (
              <tr key={index} className={styles.trcolor}>
                <td className={styles.tdspace}>/{cmd.name}</td>
                <td>{cmd.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.table}>
        <table>
          <tbody>
            <tr className={styles.headers}>
              <td>Info Commands</td>
            </tr>
            {info.map((cmd, index) => (
              <tr key={index} className={styles.trcolor}>
                <td className={styles.tdspace}>/{cmd.name}</td>
                <td>{cmd.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.table}>
        <table>
          <tbody>
            <tr className={styles.headers}>
              <td>Utilities Commands</td>
            </tr>
            {utils.map((cmd, index) => (
              <tr key={index} className={styles.trcolor}>
                <td className={styles.tdspace}>/{cmd.name}</td>
                <td>{cmd.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  )
}